export enum LANGUAGE {
  DE = 'de',
  EN = 'en',
  FR = 'fr',
}
